export default defineI18nConfig(() => {
  return {
    fallbackLocale: 'en',
    legacy: false,
    locale: 'en',
  }
})
